import type { Theme } from '@mui/material'

/**
 * Base skeleton styles shared across all chart widgets
 */
export const baseSkeletonStyles = {
  graph: {
    /**
     * Common container style for chart widget skeletons
     */
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      gap: ({ spacing }: Theme) => spacing(1),
      height: ({ spacing }: Theme) => spacing(38),
    },
  },
} as const
